import { Component, Input, OnInit } from "@angular/core";
import { Wiring } from "../../../../../codegen/out/types";

@Component({
  selector: "app-ru-x-wiring-diagram",
  templateUrl: "./ru-x-wiring-diagram.component.html",
  styleUrls: ["./ru-x-wiring-diagram.component.scss"],
  standalone: false,
})
export class RuXWiringDiagramComponent implements OnInit {
  @Input() wiring: Wiring;

  terminals = {};

  ngOnInit(): void {
    for (const terminal of this.wiring.terminals) {
      this.terminals[terminal.device] = terminal;
    }
  }
}
